import { loadPref, savePrefs } from './persist.svelte.js';

const MAX_RECENTS = 12;

export const recentState = $state({
  items: loadPref('recent_items', []),
});

export function addRecent(item) {
  if (!item?.id || !item?.kind) return;
  recentState.items = [
    { ...item, openedAt: Date.now() },
    ...recentState.items.filter((entry) => !(entry.kind === item.kind && entry.id === item.id)),
  ].slice(0, MAX_RECENTS);
  savePrefs('recent_items', $state.snapshot(recentState.items));
}

export function clearRecents() {
  recentState.items = [];
  savePrefs('recent_items', []);
}
